import { commonEnvironment } from './environment.common';

export const environment = {
  ...commonEnvironment,
  envName: 'Live Dev'
};
